import React from 'react';
import PropTypes from 'prop-types';

import RichText from 'dpl/prismic/components/RichText';
import { StructuredTextPropTypes } from 'dpl/prismic/utils/customPropTypes';
import { get } from 'dpl/shared/utils/object';

export default function Highlights({ sliceData }) {
  const headerFeatureContent = get(sliceData, 'primary.header_feature_content');
  if (!headerFeatureContent) return null;

  return (
    <div className="PrismicHighlights">
      <p className="b mb4">Highlights</p>
      {headerFeatureContent && <RichText content={headerFeatureContent} />}
    </div>
  );
}

Highlights.propTypes = {
  sliceData: PropTypes.shape({
    primary: PropTypes.shape({
      header_feature_content: StructuredTextPropTypes
    }).isRequired
  }).isRequired
};
